import { CourseTrackRepository } from "../repository";
import http from "../http/index";
import {
  Course,
  CourseTrack,
  CourseTrackMandatory
} from "../../../domain/entities/entities";
import { wrapErrorHandler } from "../utils/wrap_error_handler";
import { formatSearchQuery } from "../../presentation/components/mixins";
import { Order } from "../../../domain/entities/order";

class _CourseTrackRepository implements CourseTrackRepository {
  async get(courseTrackID: number): Promise<CourseTrack> {
    return wrapErrorHandler<CourseTrack>(async () => {
      const response = await http.get(
        `/api/decola/courseTrack/${courseTrackID}`
      );
      return response.data.courseTrack;
    });
  }

  list(): Promise<CourseTrack[]> {
    return wrapErrorHandler<CourseTrack[]>(async () => {
      const response = await http.get("/api/decola/courseTrack/list");
      return response.data.courseTracks;
    });
  }

  listBySchool(schoolID: number): Promise<CourseTrack[]> {
    return wrapErrorHandler<CourseTrack[]>(async () => {
      const response = await http.get(
        `/api/decola/courseTrack/school/${schoolID}`
      );
      return response.data.courseTracks;
    });
  }

  listBySearch(search: string): Promise<CourseTrack[]> {
    return wrapErrorHandler<CourseTrack[]>(async () => {
      const response = await http.get(
        `/api/decola/courseTrack/globalSearch?search=${formatSearchQuery(
          search
        )}`
      );
      return response.data;
    });
  }

  listCourseTrackTraining(
    courseTrackID: number,
    index: number
  ): Promise<CourseTrackMandatory> {
    return wrapErrorHandler<CourseTrackMandatory>(async () => {
      const response = await http.get(
        `api/decola/courseTrack/${courseTrackID}/trainings`,
        {
          params: { index, limit: 5 }
        }
      );
      return response.data;
    });
  }

  getRequiredCourseTrack(order: Order): Promise<CourseTrack[]> {
    return wrapErrorHandler<CourseTrack[]>(async () => {
      const response = await http.get(`api/decola/courseTrack/required`, {
        params: {
          filterType: order.filterType
        }
      });
      return response.data.courseTracks;
    });
  }
}

export const interfaceCourseTrackRepository: CourseTrackRepository = new _CourseTrackRepository();
